import ArrowLeftThinIcon from '@assets/icons/arrow-left-thin.svg';
import React, { useEffect } from 'react';
import { AnalyticEvent } from '@/analytics/fennel/registry';
import { APP_MODAL_ROUTES } from '@/navigators/routes';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { createStyles } from '@/contexts/theme-context';
import { fennelTrack } from '@/analytics/fennel/hook';
import { ItemDetails } from './item-details';
import { TouchableOpacity } from 'react-native';

interface Props {
  origin: string;
  restaurantUUID: string;
  setShowActionSheet: (show: boolean) => void;
  showActionSheet: boolean;
  supplierUUID: string;
  variantPackUUID: string;
}

export const ItemDetailsActionSheet: React.FC<Props> = ({
  restaurantUUID,
  supplierUUID,
  variantPackUUID,
  origin,
  setShowActionSheet,
  showActionSheet,
}) => {
  const [styles, theme] = useStyles();

  useEffect(() => {
    fennelTrack(AnalyticEvent.ITEM_DETAIL_VIEW, {
      origin,
      restaurantUUID,
      screenName: APP_MODAL_ROUTES.ItemDetails,
      supplierUUID,
      variantPackUUID,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BaseActionSheet
      headerContent={
        <TouchableOpacity
          accessibilityRole="button"
          onPress={() => setShowActionSheet(false)}
        >
          <ArrowLeftThinIcon
            fill={theme.sk.color.icon.primary}
            height={24}
            width={24}
          />
        </TouchableOpacity>
      }
      isVisible={showActionSheet}
      modalStyle={styles.actionSheet}
      onClose={() => {
        setShowActionSheet(false);
      }}
      showCloseButton={false}
    >
      <ItemDetails
        restaurantUUID={restaurantUUID}
        supplierUUID={supplierUUID}
        variantPackUUID={variantPackUUID}
      />
    </BaseActionSheet>
  );
};

const useStyles = createStyles(() => ({
  actionSheet: {
    flex: 1,
  },
}));
